import { render } from "./SuperAdminReports.vue?vue&type=template&id=51a990ee&scoped=true"
import script from "./SuperAdminReports.vue?vue&type=script&lang=js"
export * from "./SuperAdminReports.vue?vue&type=script&lang=js"

import "./SuperAdminReports.vue?vue&type=style&index=0&id=51a990ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a990ee"]])

export default __exports__